import {FC} from 'react';
import {createPortal} from 'react-dom';
import {ResponsiveModal} from '~library/organisms/ResponsiveModal';

interface ConfirmRemoveSectionModalProps {
  message?: string;
  primaryCtaText?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  qaId: string;
}

export const ConfirmRemoveSectionModal: FC<ConfirmRemoveSectionModalProps> = ({
  message = 'Are you sure you want to remove this section from your Invitation?',
  primaryCtaText = 'Yes, remove it',
  isOpen,
  onClose,
  onConfirm,
  qaId,
}) =>
  createPortal(
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      title={message}
      primaryText={primaryCtaText}
      primaryAction={onConfirm}
      modalId={qaId}
    />,
    document.body
  );
